export class OperationService {
  constructor() {
    this.dataOperations = [
      { text: "Created", operationType: "Created" },
      { text: "Updated", operationType: "Updated" },
      { text: "Deleted", operationType: "Deleted" },
    ];
  }
  search(value) {
    return this.dataOperations.filter(
      (elem) => elem.text.indexOf(value) !== -1
    );
  }
  async get() {
    return Promise.resolve({ data: { records: this.dataOperations } });
  }
}
